export default function isLowRoofPitch(roofPitch) {
  if(!roofPitch) {
    return false;
  }

  return roofPitch >= 7 && roofPitch < 10;
}
